import styled from 'styled-components'

const StyledPageTitle = styled.h3`
  margin-bottom: 0;
  text-transform: capitalize;
  font-size: 24px;
`

export default StyledPageTitle
